
import { accessReducer } from "../reducer/AccessReducer";

export const reducer = accessReducer;
